module.exports = __webpack_public_path__ + "assets/img/zfbpay.5664b6a6.svg";